module.exports = __webpack_public_path__ + "static/img/tablets-blast3.97799c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blast/tablets-blast3.jpg
// module id = GzFC
// module chunks = 1